module.exports = __webpack_public_path__ + "static/media/logo-paypal.9fdb9291.png";